/* unplugin-vue-components disabled */import script from "./WinnerRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./WinnerRecord.vue?vue&type=script&setup=true&lang=js"

import "./WinnerRecord.vue?vue&type=style&index=0&id=2ec52b0d&lang=less"

const __exports__ = script;

export default __exports__